import { openExternalLink } from './fnUtils'

export const openWhatsappSupport = (): void => {
  openExternalLink(import.meta.env.VITE_APP_WHATSAPP_SUPPORT_URL)
}
